var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center card mb-4",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"card-body"},[_c('img',{staticClass:"full-banner-image",attrs:{"src":_vm.$store.apiRoot + 'resources/referral_banner_01.png?c='+_vm.rand}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }